<template>
  <div class="full-width">
    <div class="full-width flex-row align-items-center">
      <div
        class="chevron chevron-left"
        v-if="0 !== page"
      >
        <IconsChevronLeft
          color="primary"
          @click="previousPage"
        />
      </div>
      <div class="full-width flex-row gap24">
        <template v-for="product in getProductPage()">
          <ProductCard
            class="flex1"
            :product="product"
          />
        </template>
        <template
          v-if="pageCount - 1 === page"
          v-for="i in range(3 - lastPageProducts)"
        >
          <div class="flex1 p-2"></div>
        </template>
      </div>
      <div
        class="chevron chevron-right"
        v-if="pageCount - 1 !== page"
      >
        <IconsChevronRight
          color="primary"
          @click="nextPage"
        />
      </div>
    </div>
    <div class="dots">
      <div
        v-for="index in range(pageCount)"
        :class="{ dot: true, active: index === page }"
      />
    </div>
  </div>
</template>

<script setup>
import { range } from "lodash-es";
import { useReviewStore } from "~~/stores/review";

const reviewStore = useReviewStore();

const route = useRoute();

const products = ref([]);

const page = ref(0);

const pageCount = computed(() => Math.ceil(products.value.length / 3));

const lastPageProducts = computed(() => products.value.length % 3);

const nextPage = () => {
  if (page.value < products.value.length / 3 - 1) {
    ++page.value;
  }
};

const previousPage = () => {
  if (page.value > 0) {
    --page.value;
  }
};

const getProductPage = () => {
  return products.value.slice(page.value * 3, (page.value + 1) * 3);
};

onMounted(async () => {
  await reviewStore.fetchBestSellingProducts(route.params.financier);
  products.value = reviewStore.bestSellingProducts.bestSellingProductResponses;
});
</script>

<style scoped lang="scss">
.chevron {
  position: relative;
  background: magenta;

  svg {
    top: -16px;
    cursor: pointer;
  }

  &-left svg {
    position: absolute;
    left: -48px;
  }

  &-right svg {
    position: absolute;
    right: -48px;
  }
}

.dots {
  display: flex;
  gap: 10px;
  padding: 16px 0;
  width: fit-content;
  margin: auto;
  .dot {
    width: 12px;
    height: 12px;
    border-radius: 12px;
    background: var(--gray200);

    &.active {
      background: var(--brandPrimary);
    }
  }
}
</style>
